import Vue from 'vue'
import $ from "jquery";
import 'bootstrap';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import './css/main.css';
import './css/editor.css';

import moment from 'moment';
import Croppa from 'vue-croppa';
import vSelect from 'vue-select'
import datePicker from 'vue-bootstrap-datetimepicker';
import draggable from 'vuedraggable';
import ObjectHash from 'object-hash';
import VueApexCharts from 'vue-apexcharts'
import VueCodemirror from 'vue-codemirror'

import 'codemirror/mode/css/css.js';
import 'codemirror/mode/htmlmixed/htmlmixed.js';
import 'codemirror/lib/codemirror.css'
import 'vue-select/dist/vue-select.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import defaultComponents from './DefaultComponents';

import VuejsDialog from 'vuejs-dialog';
import VuejsDialogMixin from 'vuejs-dialog/dist/vuejs-dialog-mixin.min.js';

import Block from './components/Block.vue';
import Container from './components/Container.vue';
import Unsubscribe from './components/Unsubscribe.vue';
import ColorPicker from './components/ColorPicker.vue';
import FileBrowser from './components/FileBrowser.vue';
import BlockParams from './components/BlockParams.vue';
import TreeView from './components/TreeView.vue';
import Editable from './components/Editable.vue';
import CKEditor from './components/CKEditor.vue';
import Button from './components/Button.vue';
import EmojiPicker from './components/EmojiPicker.vue';
import UrlPrompt from './components/UrlPrompt.vue';
import AltPrompt from './components/AltPrompt.vue';
import UrlInput from './components/UrlInput.vue';
import GAFilter from './components/analytics/GAFilter.vue';
import Wrapper from './components/Wrapper.vue';
import ArrayInput from './components/ArrayInput.vue';
import DictInput from './components/DictInput.vue';
import QuickDates from './components/QuickDates.vue';
import RangePicker from './components/RangePicker.vue';
import SocialShare from './components/SocialShare.vue';
import SocialLinks from './components/SocialLinks.vue';
import DateTimePicker from './components/DateTimePicker.vue';
import DatePicker from './components/DatePicker.vue';

import App from './App.vue';
import MailsApp from './MailsApp.vue';
import MailsImportApp from './MailsImportApp.vue';
import IconSetsApp from './IconSetsApp.vue';
import TemplatesApp from './TemplatesApp.vue';
import PermissionsApp from './PermissionsApp.vue';
import EmailApp from './EmailApp.vue';

Vue.config.productionTip = false;

Vue.use(Croppa);
Vue.use(datePicker);
Vue.use(draggable);
Vue.use(VuejsDialog, {html: true, loader: false, okText: 'Применить', cancelText: 'Отмена'})

Vue.dialog.registerComponent('urlprompt', UrlPrompt);
Vue.dialog.registerComponent('altprompt', AltPrompt);

Vue.component('block', Block);
Vue.component('container', Container);
Vue.component('unsubscribe', Unsubscribe);
Vue.component('color-picker', ColorPicker);
Vue.component('filebrowser', FileBrowser);
Vue.component('blockparams', BlockParams);
Vue.component('treeview', TreeView);
Vue.component('editable', Editable);
Vue.component('ckeditor', CKEditor);
Vue.component('btn', Button);
Vue.component('emojipicker', EmojiPicker);
Vue.component('url-input', UrlInput);
Vue.component('v-select', vSelect);
Vue.component('array-input', ArrayInput);
Vue.component('ga-user-query', GAFilter);
Vue.component('wrapper', Wrapper);
Vue.component('quick-dates', QuickDates);
Vue.component('array-input', ArrayInput);
Vue.component('dict-input', DictInput);
Vue.component('range-picker', RangePicker);
Vue.component('sociallinks', SocialLinks);
Vue.component('share', SocialShare);
Vue.component('apexchart', VueApexCharts)
Vue.component('datetime-picker', DateTimePicker)
Vue.component('date-picker', DatePicker)


Vue.use(vSelect);
Vue.use(ArrayInput);
Vue.use(DictInput);
Vue.use(Wrapper);
Vue.use(QuickDates);
Vue.use(RangePicker);
Vue.use(DateTimePicker);
Vue.use(DatePicker);

Vue.use(Block);
Vue.use(UrlInput);
Vue.use(Container);
Vue.use(Unsubscribe);
Vue.use(ColorPicker);
Vue.use(FileBrowser);
Vue.use(BlockParams);
Vue.use(Editable);
Vue.use(TreeView);
Vue.use(Button);
Vue.use(EmojiPicker);
Vue.use(CKEditor);
Vue.use(SocialLinks);
Vue.use(SocialShare);
Vue.use(GAFilter);
Vue.use(VueCodemirror);


window.Vue = Vue;
window.EditorApp = App;
window.TemplatesApp = TemplatesApp;
window.IconSetsApp= IconSetsApp;
window.MailsApp = MailsApp;
window.MailsImportApp = MailsImportApp;
window.PermissionsApp = PermissionsApp;
window.EmailApp = EmailApp;
window.defaultComponents = defaultComponents;
window.$ = $;

window.moment = moment;
window.objectHash = ObjectHash;

window.mouseBtnPressed = false;
window.resizeActive = false;
window.dragActive = false;



$(function() {
    var flashTimeout = null;

    document.body.ondrop = function (event) {
        event.preventDefault();
        event.stopPropagation();
    }

    document.ondragstart = function (ev) {
        var img = document.createElement('img')
        img.src = '';
        ev.dataTransfer.setDragImage(img, 0, 0)
    }

    document.addEventListener('mousedown', function(){ 
        window.mouseBtnPressed = Date.now();
    }, true);


    document.addEventListener('mouseup', function(){
        window.mouseBtnPressed = false;
    }, true);

    function hideFlash() {
        flashTimeout = setTimeout(function(){
            $('#flash-container').css({'height': '0px'});
        }, 5000)
    }

    if ($('#flash-container').length) {
        hideFlash();

        $('#flash-container').on('mouseenter', function(){
            clearTimeout(flashTimeout);
            $('#flash-container').css({'height': 'auto'});
        })

        $('#flash-container').on('mouseleave', function(){
            hideFlash();
        })
    }
});
